import { render } from "./CreateEditBankDetail.vue?vue&type=template&id=644b4810"
import script from "./CreateEditBankDetail.vue?vue&type=script&lang=js"
export * from "./CreateEditBankDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__